import { useQuery } from '@tanstack/react-query';
import { useConfig } from 'hooks/use-config';
import { getOidcUiConfig, OidcUiConfigResponse } from '../services/captcha-config-service';

export const useCaptchaConfig = () => {
  const { configurationSettings } = useConfig();
  const tenantId = configurationSettings.blocksKey;

  return useQuery<OidcUiConfigResponse>({
    queryKey: ['oidcUiConfig', tenantId],
    queryFn: () => getOidcUiConfig(configurationSettings, tenantId),
    staleTime: 5 * 60 * 1000,
  });
};
